<template>
  <SearchInvites />
</template>

<script>
import SearchInvites from '@/components/RsvpInvites/SearchInvites.vue'

export default {
  components: {
    SearchInvites,
  },
}
</script>

<style lang="scss" scoped></style>
